import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { getQaSelector } from '../../../utils/common'
import {
  BUTTON_ICON_MINIMIZE_POSITION,
  ButtonIcon,
  ButtonIconMinimize,
} from '../../Button'
import { ICON_HEIGHT_24 } from '../../Icon'
import Text from '../../Text'

import {
  QA_NAME_MINIMIZED_MODAL_CLOSE_BTN,
  QA_NAME_MINIMIZED_MODAL_ITEM,
  QA_NAME_MINIMIZED_MODAL_RESTORE_BTN,
} from './MinimizedModalsTrayItem.constants'

import * as styles from './MinimizedModalsTrayItem.module.css'

import CloseIcon from '../../../icons/close.svg'

function MinimizedModalsTrayItem({
  className = styles.MinimizedModalsTrayItem,
  qaName,
  title,
  onClose,
  onRestore,
}) {
  const { t } = useTranslation()

  const qaProps = getQaSelector({
    context: QA_NAME_MINIMIZED_MODAL_ITEM,
    value: qaName,
  })

  return (
    <div {...qaProps} className={className} onClick={onRestore}>
      <Text className={styles.title}>{title}</Text>
      <ButtonIconMinimize
        iconPosition={BUTTON_ICON_MINIMIZE_POSITION.top}
        qaName={QA_NAME_MINIMIZED_MODAL_RESTORE_BTN}
        tooltip={t('Modal.MinimizedItemRestoreTooltipKey')}
        tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        onClick={onRestore}
      />
      <ButtonIcon
        Icon={CloseIcon}
        className={styles.closeButton}
        height={ICON_HEIGHT_24}
        qaName={QA_NAME_MINIMIZED_MODAL_CLOSE_BTN}
        tooltip={t('Modal.CloseTooltipKey')}
        tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        onClick={onClose}
      />
    </div>
  )
}

export default MinimizedModalsTrayItem
